enum PaymentProvider {
  Solupay = 'Solupay',
  SecurePay = 'SecurePay',
  Citi = 'Citi',
}
export default PaymentProvider;
